import { Controller } from "@hotwired/stimulus"

let widgetsPromise

function loadWidgets() {
  if (window.twttr?.widgets?.createTweet) return Promise.resolve(window.twttr.widgets)

  if (!widgetsPromise) {
    widgetsPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = "https://platform.twitter.com/widgets.js"
      script.async = true
      script.onload = () => {
        if (window.twttr?.widgets?.createTweet) resolve(window.twttr.widgets)
        else reject(new Error("X widgets unavailable"))
      }
      script.onerror = reject
      document.head.appendChild(script)
    })
  }
  return widgetsPromise
}

export default class extends Controller {
  static targets = ["embed", "link"]
  static values = { id: String }

  connect() {
    this.reset = this.clear.bind(this)
    document.addEventListener("turbo:before-cache", this.reset)
    this.render()
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.reset)
    this.clear()
  }

  clear() {
    this.mount = null
    this.embedTarget.replaceChildren()
    this.linkTarget.hidden = false
  }

  async render() {
    this.clear()
    const mount = document.createElement("span")
    this.mount = mount
    this.embedTarget.appendChild(mount)

    try {
      const widgets = await loadWidgets()
      if (this.mount !== mount) return

      const widget = await widgets.createTweet(this.idValue, mount, {
        dnt: true,
        lang: document.documentElement.lang || "es",
        theme: this.element.closest('[data-bs-theme]')?.dataset.bsTheme === "dark" ? "dark" : "light"
      })
      if (this.mount === mount && widget) this.linkTarget.hidden = true
    } catch (_error) {
      // The original link remains usable when X is blocked or the post is unavailable.
    }
  }
}
